import * as React from "react";
import { api, user } from "src/services/api";
import { goToRicarica, currentURL } from "src/services/browser";
import { classNames } from "src/services/theme";
import { FormState, Form, Fieldset, bindToAPI, resetState, _ } from "src/services/form";
import { Formatters, Loading, Modal } from "src/components/ui";

interface Props {
  action: string;
  params?: any;
  label: string;
  crediti: number;
  onPay?: Function;
  onCancel?: Function;
}

interface State {
}

export default class BtnInstantPay extends React.Component<Props, State> {
  
  async pay() {
    const { action, params, onPay } = this.props;
    const args = {
      action,
      ...params
    };
    const scuole = await api({
          url: "ecommerce/crediti/paga",
          method: 'post',
          params: args
    });
    if (onPay) onPay()
  }
  
  render() {
    const { label, crediti, onPay, onCancel } = this.props;
    const { } = this.state;
    if (user.crediti >= crediti) {
      return (
        <div className="ecommerce_BtnInstantPay">
          <section>
            <div onClick={() => this.pay()}>
              <div>
                <strong>{label.toUpperCase()}</strong>
                <br />
                costo: {crediti} crediti
              </div>
              <span className="icon-checked" />
            </div>
            <nav>
              <a onClick={() => { if (onCancel) onCancel() }}>Annulla</a>
            </nav>
          </section>
        </div>
      );
    } else {
      return (
        <div className="ecommerce_BtnInstantPay_disabled">
          <div>
            <span className="icon-warning_shield" />
            Ops! Non hai crediti a sufficienza!
          </div>
          <section>
            <div><button className="main2 rounded block" onClick={() => goToRicarica(currentURL())}><span>Ricarica crediti</span></button></div>
            <nav>
              <a onClick={() => { if (onCancel) onCancel() }}>Annulla</a>
            </nav>
          </section>
        </div>
      );
    }
    
  }
}


// WEBPACK FOOTER //
// ./src/components/ecommerce/BtnInstantPay.tsx